import React from "react";
import { HitSizePickerProps } from "./types/HitSizePickerProps";
import { useDispatch } from "react-redux";
import {
  setSizePickerOptions,
  setIsVisible,
} from "../../../Actions/SizePicker.action";
import { setSizeGuide } from "../../../Actions/SizeGuide.action";
import { receive, showMiniCart } from "../../../Actions/Cart.action";
import { add as addToCartService } from "../../../Services/Cart.service";
import { translate } from "../../../Services/translation";
import ReactDOM from "react-dom";

const HitSizePicker = ({
  children,
  className,
  hit,
  formattedPrice,
  formattedCampaignPrice,
  formattedDiscountInPercentage,
}: HitSizePickerProps) => {
  const dispatch = useDispatch();
  const sizeGuideOptions = {
    visible: true,
    customContent: hit.sizeGuide || "",
  };
  const sizePickerOptions = {
    visible: true,
    sizeHint: hit.sizeHintShort,
    sizes: hit.variants.map((variant) => {
      const urlObj = new URL(hit.url, window.location.href);
      if (hit.__queryID) {
        urlObj.searchParams.set("queryID", hit.__queryID);
      }
      if (hit.variants.length > 1) {
        urlObj.searchParams.set("size", variant.size);
      }

      return {
        textOptionValue: variant.id,
        size: variant.size,
        url: urlObj.toString(),
        isFewLeft: false,
        isInStock: variant.inStock,
        isActive: variant.inStock,
        articleNumber: variant.id,
      };
    }),
    renderFunction: (sizePicker) =>
      ReactDOM.createPortal(sizePicker, document.body),
    className: "size-picker--desktop-centered",
    header: (
      <div className="size-picker__header">
        <div className="size-picker__header-content size-picker__header-content--with-product-name">
          <div className="size-picker__header-content-vertical">
            {hit.brand && (
              <span className="size-picker__header-content-vertical__brand">
                {hit.brand}
              </span>
            )}
            {hit.name && (
              <span className="size-picker__header-content-vertical__product-name">
                {hit.name}
              </span>
            )}
          </div>
          <div className="size-picker__header-content-vertical size-picker__header-content-vertical--last">
            <div className="size-picker__header-content-vertical__product-price">
              {formattedCampaignPrice && formattedPrice ? (
                <>
                  <span className="size-picker__header-content-vertical__product-price__campaign-price">
                    {formattedCampaignPrice}
                  </span>
                  <span className="size-picker__header-content-vertical__product-price__old-price">
                    {formattedPrice}
                  </span>
                  <span className="size-picker__header-content-vertical__product-price__amount-off">
                    {formattedDiscountInPercentage}
                  </span>
                </>
              ) : formattedPrice ? (
                <span className="size-picker__header-content-vertical__product-price__price">
                  {formattedPrice}
                </span>
              ) : null}
            </div>
            {hit.sizeGuide &&
            document.querySelector(
              '#all-size-guides [data-size-guide-name="' + hit.sizeGuide + '"]'
            ) ? (
              <a
                className="size-picker__header-content-vertical__product-size-guide-link"
                onClick={() => dispatch(setSizeGuide(sizeGuideOptions))}
              >
                {translate("global.size-guide")}
              </a>
            ) : null}
          </div>
        </div>
      </div>
    ),
    onItemSelected: async (size) => {
      dispatch(receive(await addToCartService(size.articleNumber, 1)));
      dispatch(setIsVisible(false));
      dispatch(showMiniCart());
    },
  };
  const showSizePicker = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    dispatch(setSizePickerOptions(sizePickerOptions));
  };

  return (
    <a onClick={showSizePicker} href="#" className={className}>
      {children}
    </a>
  );
};

export default HitSizePicker;
